import { useFormik } from "formik";
import { useEffect, useState } from "react";
import * as yup from "yup";
import { notification } from "antd";
import { TextMediumXS } from "../../../../../Components/Text/MediumText";
import { useToast } from "../../../../../Components/Others/ToastServices";
import axiosInstance from "../../../../../Services/axiosCommon";
import { NuInputSetting } from "../../../../../Components/Utils/Input";

const Equipment = () => {
  const [data, setData] = useState([]);
  const toast = useToast();
  const [selectedFile, setSelectedFile] = useState(null);
  const [api, contextHolder] = notification.useNotification();

  const [createNew, setCreateNew] = useState({
    name: "",
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      name: yup.string().required("Name is required"),
    }),
    onSubmit: (value, { resetForm }) => {
      let formData = new FormData();
      formData.append("json_data", JSON.stringify(value));

      if (selectedFile !== null) {
        selectedFile.forEach((file) => {
          formData.append("equipmentImage", file);
        });
      } else {
        formData.append("equipmentImage", []);
      }

      axiosInstance
        .post(`/equipments/new-equipment`, formData)
        .then((res) => {
          if (res.data) {
            resetForm();
            GetData();
            toast.open({
              type: "success",
              message: `Equipment Added successfully`,
            });
          } else {
            toast.open({
              type: "error",
              message: `Equipment Add failed`,
            });
          }
        })
        .catch(() => {
          toast.open({
            type: "error",
            message: "Server error",
          });
        });
    },
  });

  const GetData = () => {
    axiosInstance
      .get(`/equipments/drop-down`)
      .then((res) => {
        let fetchedEquipments = res?.data|| [];
        setData(fetchedEquipments);
      })
      .catch((err) => {
        console.log("error", err);
      });
  };

  const handleDelete = (id) => {
    axiosInstance.delete(`/equipments/${id}`).then((res) => {
      if (res?.status === 200) {
        GetData();
        toast.open({
          type: "success",
          message: `Equipment Deleted successfully`,
        });
      } else {
        toast.open({
          type: "error",
          message: `Equipment Delete failed`,
        });
      }
    });
  };

  useEffect(() => {
    GetData();
  }, []);

  return (
    <div className="w-full">
      {contextHolder}
      <form onSubmit={formik.handleSubmit}>
       <div className={`w-full text-xs`}>
          <div className="px-3 mb-1">
            <label className="font-medium text-textColor-500">
               Facilities / Building
            </label>
            <NuInputSetting
              type="text"
              placeholder="Name"
              formik={formik}
              name="name"
            />
          </div>
        </div>
      </form>
      <div className=" px-3">
        <div className="w-full rounded-lg h-44 bg-[#f5f3ff] border border-gray-300 overflow-x-hidden overflow-y-auto">
          <ul>
            {Array.isArray(data) &&
              data.map((List, idx) => (
                <li
                  key={idx}
                  className="m-1 flex justify-between items-center text-xs bg-white border border-gray-300 rounded text-main-title py-2 px-2 hover:bg-[#B3EBD7] hover:bg-opacity-50"
                >
                  <TextMediumXS
                    color="text-[#697565]"
                    content={List?.name || "-"}
                  />
                  {List?.id && (
                    <span
                      onClick={() => handleDelete(List?.id)}
                      className="text-blue-900 cursor-pointer"
                    >
                      x
                    </span>
                  )}
                </li>
              ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Equipment;
